import {Scene} from 'scene';
import {Animation} from 'animation';
import UiScene from './uiscene';
import Settings from "./settings";
import SettingsGameMode from "./settings_game_mode";
import Help from "./help";
import {goLobby} from 'minigame_client/minigame_client'
import AccountChangedWindow from "./account_changed_window";
import { addLabel } from 'src/library/minigame_client/ui/common/ui'

import SETTINGS from 'settings'


let GResultOrel = 0;        // head - gerb
let GResultReshka = 1;      // tail - number

// сохраняем состояние между реинициализациями при повороте экрана
let GlobalSavedGameState = {
    backgroundInd: 0,
    lastModelData: {},
    lastModelAccount: {},
    isAutoEnable: false,
    isSoundEnable: false,
};

export default class MainScene extends Scene
{
    constructor(space, configGame, configMenu, configPanel) {

        super();

        let self = this;

        this.space = space;

        const packFolder = configGame.packFolder;
        const pathRes = "res/" + configGame.pathFolder;
        const screen = configGame.Screen;
        this.isDesktopHorizontal = configGame.type === "DesktopHorizontal";

        const config = configGame.MainScene;

        this.constStartAnimSpeed = this.isDesktopHorizontal ? 2.0 : 0.5;

        this.sndLose = sounds.get("res/sounds/lose");
        this.sndWin = sounds.get("res/sounds/win");
        this.sndRotate = sounds.get("res/sounds/rotate");

        this.arrBackgrounds = [];
        this.arrBackgroundsPath = [];
        const count = this.isDesktopHorizontal ? 6 : 6;
        for (let i = 0; i < count; ++i) {
            this.arrBackgroundsPath.push(pathRes + "back/background_%d.jpg".$(i));
            let back = new PIXI.Sprite(PIXI.utils.TextureCache[this.arrBackgroundsPath[i]]);
            back.visible = false;
            this.addChild(back);
            this.arrBackgrounds.push(back);
        }
        if (!SETTINGS.transparent_render)
            this.arrBackgrounds[0].visible = true;
        else {
            this._setHTMLBackground(0);
        }

        this.frameUi = new PIXI.Sprite(PIXI.utils.TextureCache[pathRes + "frame_ui.png"]);
        this.frameUi.position.set(config.frameUi.pos.x, config.frameUi.pos.y);
        this.frameUi.visible = this.isDesktopHorizontal;
        this.addChild(this.frameUi);

        if (this.isDesktopHorizontal) {
            let createLogoAnim = function (x, y, name, countFrames) {
                let anim = Animation.byFrameName(name, countFrames);
                anim.position.set(x, y);
                anim.animationSpeed = 0.2;
                anim.loop = false;
                self.addChild(anim);

                return anim;
            };

            this.animLogo0 = createLogoAnim(40, 326, packFolder + "logo_0_%d.png", 24);
            this.animLogo1 = createLogoAnim(40, 326, packFolder + "logo_1_%d.png", 31);
            this.animLogoJackpot = createLogoAnim(1500, 0, packFolder + "logo_jackpot_%d.png", 20);

            let animLogoComplete = function () {
                self.animLogo0.visible = !self.animLogo0.visible;
                self.animLogo1.visible = !self.animLogo1.visible;
                let anim = self.animLogo0.visible ? self.animLogo0 : self.animLogo1;
                anim.gotoAndStop(0);
                self.timeIdAnimLogo = setTimeout(function () {
                    anim.gotoAndPlay(0);
                }, 7000);
            };

            this.animLogo0.onComplete = animLogoComplete;
            this.animLogo1.onComplete = animLogoComplete;
            this.animLogoJackpot.onComplete = function () {
                self.timeIdAnimLogoJackpot = setTimeout(function () {
                    self.animLogoJackpot.gotoAndPlay(0);
                }, 3000);
            };

            this.animLogo1.animationSpeed = 0.3;
            this.animLogo1.visible = false;
            this.animLogo0.gotoAndPlay(0);
            this.animLogoJackpot.gotoAndPlay(0);

            this.logoFix = new PIXI.Sprite(PIXI.utils.TextureCache[packFolder + "logo_bet_fix.png"]);
            this.logoFix.position.set(config.logoFix.pos.x, config.logoFix.pos.y);
            this.addChild(this.logoFix);

            this.logoX2 = new PIXI.Sprite(PIXI.utils.TextureCache[packFolder + "logo_bet_x2.png"]);
            this.logoX2.position.set(config.logoX2.pos.x, config.logoX2.pos.y);
            this.logoX2.visible = false;
            this.addChild(this.logoX2);
        }

        let getCoinAnim = function (path, from, countFrames) {
            let tempTextures = [];
            for (let i = from; i <= countFrames; ++i) {
                tempTextures.push(PIXI.utils.TextureCache[path.$(i)]);
            }
            let anim = new Animation(tempTextures);
            anim.position.set(config.coin.pos.x, config.coin.pos.y);
            anim.loop = false;
            self.addChild(anim);
            return anim;
        };

        this.animCoinOrel = getCoinAnim(packFolder + "coin_%03d.png", config.animCoinOrel.from, config.animCoinOrel.frames);
        this.animCoinReshka = getCoinAnim(packFolder + "coin_%03d.png", config.animCoinReshka.from, config.animCoinReshka.frames);
        this.animationSpeed = this.constStartAnimSpeed;

        if (!this.isDesktopHorizontal) {
            const pos = this.animCoinOrel.position;
            this.animCoinOrelStart = getCoinAnim(packFolder + "head/start/coin_%03d.png", 0, 7);
            this.animCoinOrelStart.position = pos;
            this.animCoinReshkaStart = getCoinAnim(packFolder + "tail/start/coin_%03d.png", 0, 7);
            this.animCoinReshkaStart.position = pos;

            this.animCoinOrelStop = getCoinAnim(packFolder + "head/stop/coin_%03d.png", 0, 20);
            this.animCoinOrelStop.position = pos;
            this.animCoinReshkaStop = getCoinAnim(packFolder + "tail/stop/coin_%03d.png", 0, 20);
            this.animCoinReshkaStop.position = pos;

            this.animCoinOrel.visible = false;
            this.animCoinReshka.visible = false;

            // this.animCoinOrelStart.visible = false;
            this.animCoinReshkaStart.visible = false;
            this.animCoinOrelStop.visible = false;
            this.animCoinReshkaStop.visible = false;
        }


        this.ui = new UiScene(configGame, configMenu, configPanel);
        this.addChild(this.ui);

        if (!this.isDesktopHorizontal) {
            this.ui.setOnClearBetEvent((isClear) => {
                const alpha = isClear ? 0.7 : 1;
                self.animCoinOrelStart.alpha = alpha;
                self.animCoinReshkaStart.alpha = alpha;
            });
        }

        this.ui.setOnButtonPlaceBetEvent(this.onButtonPlaceBet.bind(this));
        this.ui.setOnButtonMoreEvent(this.onButtonMore.bind(this));
        this.ui.setOnButtonStopEvent(this.onButtonStop.bind(this));
        this.ui.setOnButtonSelectOrelEvent(this.onButtonSelectOrel.bind(this));
        this.ui.setOnButtonSelectReshkaEvent(this.onButtonSelectReshka.bind(this));
        // this.ui.setOnButtonBetEvent(this.onButtonBet.bind(this));
        this.ui.setOnButtonExitEvent(this.onButtonExit.bind(this));

        this.ui.setOnButtonSoundOnEvent(() => {GlobalSavedGameState.isSoundEnable = false;});
        this.ui.setOnButtonSoundOffEvent(() => {GlobalSavedGameState.isSoundEnable = true;});

        this.ui.setOnButtonAutoPlayOnEvent(this.onButtonAutoOn.bind(this));
        this.ui.setOnButtonAutoPlayOffEvent(this.onButtonAutoOff.bind(this));
        this.isAutoPlay = false;

        this.help = new Help(configGame);
        this.help.visible = false;
        this.addChild(this.help);

        this.ui.setOnButtonHelpEvent(this.onButtonHelp.bind(this));
        this.help.setOnButtonCloseEvent(this.onButtonHelp.bind(this));


        this.settings = new Settings(configGame);
        this.settings.visible = false;
        this.addChild(this.settings);

        this.ui.setOnButtonSettingsEvent(this.onButtonSettings.bind(this));
        this.settings.setOnButtonImgEvent(this.onButtonSettingsImg.bind(this));
        this.settings.setOnButtonApplyEvent(this.onButtonSettingsApply.bind(this));


        /*this.settingsGameMode = new SettingsGameMode();
        this.settingsGameMode.visible = false;
        this.addChild(this.settingsGameMode);

        this.ui.setOnButtonModeEvent(this.onButtonSettingsGameMode.bind(this));
        this.settingsGameMode.setOnButtonApplyEvent(this.onButtonSettingsGameModeApply.bind(this));*/

        this.accountChangedWindow = new AccountChangedWindow(configGame);
        this.addChild(this.accountChangedWindow);

        // this.layerBlockInput = new PIXI.Sprite(new PIXI.Texture(PIXI.Texture.EMPTY, new PIXI.Rectangle(0, 0, screen.resolution.width, screen.resolution.height)));
        this.layerBlockInput = new PIXI.Sprite(PIXI.Texture.WHITE);
        this.layerBlockInput.position.set(0, 0);
        this.layerBlockInput.interactive = true;     // block interactive of overlaid buttons
        this.layerBlockInput.visible = false;
        this.layerBlockInput.width = screen.resolution.width;
        this.layerBlockInput.height = screen.resolution.height;
        this.layerBlockInput.tint = 0x000000;
        this.layerBlockInput.alpha = 0.7;
        this.addChild(this.layerBlockInput);

        this.layerOverBlockInput = new PIXI.Container();
        this.addChild(this.layerOverBlockInput);


        // проверка - есть ли сеть после реинициализации
        space.s('checkError')
            .with(space.s('isError'),(_, arg2) => ({arg2}))
            .on(({arg2}) => {
                if (arg2) {
                    self.layerBlockInput.visible = true;
                    self.ui.addLobbyButtonToNewParrent(self.layerOverBlockInput);
                }
                else {
                    self.layerBlockInput.visible = false;
                    self.ui.resetLobbyButtonParrent();
                }
            });
        space.s('isError').to(space.s('checkError'));
        space.s('checkError').next();


        if (SETTINGS.ROOT_CONTAINERS.ui_adaptive_container && !this.isDesktopHorizontal) {
            this.removeChild(this.help);
            this.removeChild(this.settings);
            this.removeChild(this.accountChangedWindow);
            this.removeChild(this.layerBlockInput);

            SETTINGS.ROOT_CONTAINERS.ui_adaptive_container.addChild(this.help);
            SETTINGS.ROOT_CONTAINERS.ui_adaptive_container.addChild(this.settings);
            SETTINGS.ROOT_CONTAINERS.ui_adaptive_container.addChild(this.accountChangedWindow);
            SETTINGS.ROOT_CONTAINERS.ui_adaptive_container.addChild(this.layerBlockInput);
        }


        // this.credits = 100000;
        this.totalBetMin = 0;
        this.totalBetMax = 0;
        this.currencyPrecision = 0;
        this.currencyDelimiter = '.';
        this.precisionCeil = 0;

        this.userChoice = 0;
        this.animCurrent = null;

        this.isX2Mode = false;  // enable double mode
        this.win = 0;

        this.curState = null;

        this.isFirstRun = true;

        this.isCompleteShowResult = true;
        this.lastWin = 0;

        this.isReady = false;

        this.dataModelLast = null;



        this.onButtonSettingsImg(GlobalSavedGameState.backgroundInd);
        this.onAccountChanged(GlobalSavedGameState.lastModelAccount);
        this.onModelChanged(GlobalSavedGameState.lastModelData);
        this.setAutoPlayButtonState(GlobalSavedGameState.isAutoEnable);
        this.setSoundButtonState(GlobalSavedGameState.isSoundEnable);
    };

    _setHTMLBackground (ind) {
        //смена фона html
        let htmlElement = window.document.documentElement;
        htmlElement.style.backgroundImage = 'url(' + this.arrBackgroundsPath[ind] + ')';
    }

    changeModelLocal (state) {
        let dataModel = this.dataModelLast;
        dataModel.state.bet.value = this.ui.getTotalBet();
        dataModel.state.bet.side = this.userChoice === GResultOrel ? "head" : "tail";
        dataModel.isLocal = true;

        if (state === "init") {
            // из-за сети "doStop" может вызваться раньше чем отработает "doStart" на сервере - поэтому не переводим локально в состояние "init"
            // dataModel.actions = ["doStart", "betSet"];
            // this.onModelChanged(dataModel);
        }
        if (state === "spin") {
            dataModel.actions = ["doStop", "doTake"];
            this.onModelChanged(dataModel);
        }
        if (state === "stop") {
            // ничего не делаем - прост запускаем таймер локальной модели localStateChange
        }

        // запускаем таймер локальной модели
        this.space.s( 'server_action' ).next( { name : 'localStateChange' } );
        // запускаем анимацию ожидания
        window.space.s( 'pending' ).next( true );
    }

    onModelChanged (data) {
        GlobalSavedGameState.lastModelData = data;

        // для быстрой смены ориентации экрана, отправляем в стрим пустой объект window.space.s('net').next({});
        if (Object.keys(data).length === 0 && data.constructor === Object) return;

        // игнорируем локальные изменения от математики(меняем из игры через this.changeModelLocal)
        if (data.local !== undefined && data.local !== null && data.local.is_local) return;

        // игнорируем локальные изменения для состояния "init" - а то запускается автостарт, когда сервер еще не готов
        // из-за сети "doStop" может вызваться раньше чем отработает "doStart" на сервере - поэтому не переводим локально в состояние "init"
        // if (data.isLocal && data.actions.indexOf("doStart") > -1) return;

        if (!data.isLocal) {
            this.dataModelLast = data;
            this.isReady = true;
        }

        console.log("----------- onModelChanged ------------", data);

        // TODO: заменить на значение от сервера K = CeilTo((bet * k_math)) / bet (при каждой смене ставки на клиенте)
        // this.ui.setCoefficient("1,94");

        if (data.account !== undefined && data.account !== null) {
            let arrBetsValue = data.account.settings.steps;
            let currency     = data.account.currency.code_name;
            let precision    = data.account.currency.minor_unit;
            let delimiter    = data.account.currency.separator;
            let minValue     = data.account.settings.min;
            let maxValue     = data.account.settings.max;

            // если ceilTo приходит, значит округлять ставки к БОЛЬШЕМУ(тем самым убираем копейки(центы))
            // округлять можно только при делении/умножении и потенциальный выигрыш(это для игр типа лесенка)
            // round_price(1250, 0) out: 1250, round_price(1250, 1) out: 1250, round_price(1250, 100) out: 1300
            let precisionCeil = data.account.settings.ceilTo || 0;

            this.totalBetMin = minValue;
            this.totalBetMax = maxValue;
            this.currencyPrecision = precision;
            this.currencyDelimiter = delimiter;
            this.precisionCeil = precisionCeil;

            this.ui.setBetValues(arrBetsValue, precision, delimiter, minValue, maxValue, precisionCeil);
        }

        let totalBet = this.totalBetMin;
        if (data.state.bet !== undefined && data.state.bet !== null) {
            totalBet = data.state.bet.value ? data.state.bet.value : this.totalBetMin;
            let curChoiceCoinSide = data.state.bet.side;

            this.userChoice = curChoiceCoinSide === "head" ? GResultOrel : GResultReshka;
        }
        this.ui.setModelChoiceCoinSide(this.userChoice === GResultOrel);

        let coinResult = "head";
        let win = 0;
        if (data.state.coin !== undefined && data.state.coin !== null) {
            coinResult = data.state.coin.side;
            win = data.state.win ? data.state.win.value : 0;
        }
        this.coinResult = coinResult === "head" ? GResultOrel : GResultReshka;
        this.win = win;

        if (data.settings !== undefined && data.settings !== null) {
            let settingsBackImg     = data.settings.background;
            let settingsIsX2Mode    = data.settings.mode;

            this.settings.setCurInd(settingsBackImg);
            this.onButtonSettingsImg(settingsBackImg);
            settingsIsX2Mode = false;   // TODO отключил режим удвоения - удалить, если надо включить
            this.setGameMode(settingsIsX2Mode);
        }

        let history = [];
        if (data.state.history) {
            for (let obj of data.state.history) {
                // приходит не ставка игрока, а исход раунда(если выигрыш - то сторона исхода и сторона в ставке совпали)
                history.unshift({win: obj.win, isOrel: obj.win > 0 ? obj.side === "head" : obj.side !== "head",
                    precision: obj.currency.minor_unit, delimiter: obj.currency.separator, currency: obj.currency.code_name});
            }
        }


        if (this.timeIdTakeWin) clearTimeout(this.timeIdTakeWin);

        // в игре должны быть только серверные стейты и игра должна уметь корректно переходить в любой из них в любое время по требованию сервера
        // т.е. стейт вначале очищает все и потом инициализируется для отработки своей логики(не зависит от остальных стейтов)
        let state = null;
        state = data.actions.indexOf("doStart") > -1 ? "init" : state;                                          // doStart, setbet
        state = data.actions.indexOf("doStop") > -1 ? "spin" : state;                                           // stop, take, [spinWin] - if win > 0
        state = data.actions.indexOf("doTake") > -1 && data.actions.indexOf("doStop") === -1 ? "stop" : state;  // take, setbet, [spinWin] - if win > 0

        this.ui.setModelBet(totalBet, state === "init");

        // методы математики, вызываемые игроком по нажатию на кнопки -
        // снабжаем локальным изменением модели для мгновенного отклика(смотри localStateChange)

        // что бы серверные модели повторно не запускали логику, запущенную локальной моделью
        if (this.curState === state) return;

        let self = this;

        if (state === "init") {
            this.stateInit(coinResult);
            this.ui.setHistory(history);
            console.log("<<<<< INIT");
        }
        if (state === "spin") {
            if (this.isDesktopHorizontal)
                this.stateRotate(coinResult);
            else
                this.preStateRotate(coinResult, () => {self.stateRotate(coinResult)});
            this.ui.setHistory(history);
            console.log("<<<<< Spin");
        }
        if (state === "stop") {
            this.stateStop(coinResult);
            this.ui.setHistory(history.slice(1));
            console.log("<<<<< Stop");
        }

        /*if (this.isFirstRun) {
            if (state === "init")
                this.settingsGameMode.visible = true;
        }*/
        this.isFirstRun = false;

        this.curState = state;

        if (state === "init")
            this.tryAutoStartRound();
        else
            this.ui.panelDown();
    }

    onAccountChanged (data) {
        GlobalSavedGameState.lastModelAccount = data;

        if (Object.keys(data).length === 0 && data.constructor === Object) return;

        // console.log("----------- onAccountChanged ------------", data);
        let credits     = data.value;
        let currency    = data.currency.code_name;
        let precision   = data.currency.minor_unit;
        let delimiter   = data.currency.separator;

        this.currencyPrecision = precision;
        this.currencyDelimiter = delimiter;

        this.setCredits(credits);
        this.ui.setCurrency(currency);
        this.ui.setModelBet(this.ui.getTotalBet(), this.curState === "init");
        this.ui.setModelChoiceCoinSide(this.userChoice === GResultOrel);
    }

    onAccountSelectionChanged (data) {
        console.log("----------- onAccountSelectionChanged ------------", data);
        this.accountChangedWindow.visible = true;

        this.setAutoPlayButtonState(false);
    }

    setAutoPlayButtonState (isEnabled) {
        this.ui.setAutoPlayButtonState(isEnabled);
        this.isAutoPlay = isEnabled;

        GlobalSavedGameState.isAutoEnable = isEnabled;
    }

    setSoundButtonState (isEnabled) {
        this.ui.setSoundButtonState(isEnabled);
    }

    getResult() {
        // return (Math.random() > 0.5) ? GResultReshka : GResultOrel;
        return this.coinResult;
    }

    terminate() {
        this.removeChildren();
        this.destroy();

        this.sndLose.stop();
        this.sndLose = null;
        this.sndWin.stop();
        this.sndWin = null;
        this.sndRotate.stop();
        this.sndRotate = null;

        if (SETTINGS.ROOT_CONTAINERS.ui_adaptive_container)
            SETTINGS.ROOT_CONTAINERS.ui_adaptive_container.removeChildren();

        this.layerBlockInput = null;
        this.layerOverBlockInput = null;

        for (let obj of this.arrBackgrounds) obj = null;
        this.arrBackgrounds = null;
        this.frameUi = null;
        this.logoFix = null;
        this.logoX2 = null;

        if (this.animLogo0) {
            this.animLogo0.destroy();
            this.animLogo0 = null;
        }

        if (this.animLogo1) {
            this.animLogo1.destroy();
            this.animLogo1 = null;
        }

        if (this.animLogoJackpot) {
            this.animLogoJackpot.destroy();
            this.animLogoJackpot = null;
        }

        this.animCoinOrel.destroy();
        this.animCoinOrel = null;

        this.animCoinReshka.destroy();
        this.animCoinReshka = null;

        if (this.animCoinOrelStart) {
            this.animCoinOrelStart.destroy();
            this.animCoinOrelStart = null;
        }

        if (this.animCoinReshkaStart) {
            this.animCoinReshkaStart.destroy();
            this.animCoinReshkaStart = null;
        }

        if (this.animCoinOrelStop) {
            this.animCoinOrelStop.destroy();
            this.animCoinOrelStop = null;
        }

        if (this.animCoinReshkaStop) {
            this.animCoinReshkaStop.destroy();
            this.animCoinReshkaStop = null;
        }

        if (this.timeIdAnimLogo)        clearTimeout(this.timeIdAnimLogo);
        if (this.timeIdAnimLogoJackpot) clearTimeout(this.timeIdAnimLogoJackpot);
        if (this.timeIdShowResult)      clearTimeout(this.timeIdShowResult);
        if (this.timeIdTakeWin)         clearTimeout(this.timeIdTakeWin);

        this.ui.terminate();
        this.ui = null;

        this.help.terminate();
        this.help = null;

        this.settings.terminate();
        this.settings = null;

        this.accountChangedWindow.terminate();
        this.accountChangedWindow = null;

        //this.settingsGameMode.terminate();
        //this.settingsGameMode = null;
    }

    setCredits(credits) {
        this.credits = credits;
        this.ui.setLabelCredits(credits, this.currencyPrecision, this.currencyDelimiter);
        window.parent.postMessage({isWbgMsg:true, name:'creditsChanged', credits:credits}, '*');
    }

    clearStates() {
        this.animCoinOrel.onComplete = null;
        this.animCoinOrel.visible = false;
        this.animCoinOrel.stop();

        this.animCoinReshka.onComplete = null;
        this.animCoinReshka.visible = false;
        this.animCoinReshka.stop();

        if (!this.isDesktopHorizontal) {
            this.animCoinOrelStart.onComplete = null;
            this.animCoinOrelStart.visible = false;
            this.animCoinOrelStart.stop();

            this.animCoinReshkaStart.onComplete = null;
            this.animCoinReshkaStart.visible = false;
            this.animCoinReshkaStart.stop();

            this.animCoinOrelStop.onComplete = null;
            this.animCoinOrelStop.visible = false;
            this.animCoinOrelStop.stop();

            this.animCoinReshkaStop.onComplete = null;
            this.animCoinReshkaStop.visible = false;
            this.animCoinReshkaStop.stop();
        }
    }

    stateInit(coinSide) {
        this.clearStates();

        this.ui.setState("INIT");

        if (!this.isCompleteShowResult) {
            if (this.lastWin) {
                this.sndWin.play();
            }
            else {
                this.sndLose.play();
            }
            this.ui.setResult(this.lastWin, this.userChoice === GResultOrel, this.currencyPrecision, this.currencyDelimiter);
        }

        if (this.isDesktopHorizontal) {
            this.animCurrent = coinSide === "head" ? this.animCoinReshka : this.animCoinOrel;
            this.animCurrent.visible = true;
            this.animCurrent.gotoAndStop(0);
        }
        else {
            this.animCurrent = coinSide === "head" ? this.animCoinOrelStart : this.animCoinReshkaStart;
            this.animCurrent.visible = true;
            this.animCurrent.gotoAndStop(0);
        }

        this.timeIdShowResult = setTimeout(function () {
            window.parent.postMessage({isWbgMsg: true, name: 'hideResult'}, '*');
        }, 1000);
    }

    preStateRotate(coinSide, done) {
        this.clearStates();

        let self = this;

        this.ui.setState("ROTATE", this.isX2Mode);

        if (!this.animCurrent)
            this.animCurrent = (Math.random() > 0.5) ? this.animCoinReshkaStart : this.animCoinOrelStart;

        this.sndRotate.play();
        this.animCurrent.visible = true;
        this.animCurrent.gotoAndPlay(0);
        this.animCurrent.animationSpeed = this.constStartAnimSpeed;
        this.animCurrent.onComplete = () => {
            self.animCurrent = (self.animCurrent === self.animCoinReshkaStart) ? self.animCoinReshka : self.animCoinOrel;
            self.animCurrent.gotoAndStop(0);
            done();
        }
    }

    stateRotate(coinSide) {
        this.clearStates();

        let self = this;

        this.ui.setState("ROTATE", this.isX2Mode);

        if (!this.animCurrent)
            this.animCurrent = (Math.random() > 0.5) ? this.animCoinReshka : this.animCoinOrel;
        // попали в этот стейт из Stop - анимация на последнем кадре - нужно проигрывать след. аним.
        else if (this.animCurrent.currentFrame !== 0)
            self.animCurrent = (self.animCurrent === self.animCoinOrel) ? self.animCoinReshka : self.animCoinOrel;

        this.countRotate = this.isDesktopHorizontal ? 2 : 0;
        this.animationSpeed = this.constStartAnimSpeed;
        this.animCoinOrel.animationSpeed = this.animCoinReshka.animationSpeed = this.animationSpeed;

        const lastTime = Date.now();
        let complete = null;
        let playCurAnim = function () {
            // При нет связи или долгом ответе от сервера звук вращения монеты убирать
            if ((Date.now() - lastTime) / 1000 < 5)
                self.sndRotate.play();

            self.animCurrent.visible = true;
            self.animCurrent.gotoAndPlay(0);
            self.animCurrent.onComplete = complete;
        };

        complete = function () {
            self.clearStates();

            self.animCurrent = (self.animCurrent === self.animCoinOrel) ? self.animCoinReshka : self.animCoinOrel;

            self.animationSpeed -= 0.3;
            if (self.animationSpeed < 1.0)
                self.animationSpeed = self.isDesktopHorizontal ? 1.0 : self.constStartAnimSpeed;
            self.animCurrent.animationSpeed = self.animationSpeed;

            if (self.countRotate-- <= 0 && self.isReady) {
                self.isReady = false;
                self.changeModelLocal("stop");
                self.space.s('server_action').next({name: 'doStop'});
            }

            playCurAnim();
        };

        playCurAnim();
    }

    stateStop(coinSide) {
        this.clearStates();

        let self = this;

        this.ui.setState("STOP", this.isX2Mode);

        this.isCompleteShowResult = false;
        this.lastWin = this.win;

        let animResult = coinSide === "head" ? this.animCoinReshka : this.animCoinOrel;
        if (!this.isDesktopHorizontal)
            animResult = coinSide === "head" ? this.animCoinOrel : this.animCoinReshka;

        if (!this.animCurrent)
            this.animCurrent = (Math.random() > 0.5) ? this.animCoinReshka : this.animCoinOrel;

        // if (this.animCurrent.currentFrame === 0)
        //     this.sndRotate.play();

        let animationSpeed = this.isDesktopHorizontal ? 1.0 : this.constStartAnimSpeed;

        let preComplete = null;
        let complete = null;
        this.animCurrent.visible = true;
        this.animCurrent.animationSpeed = animationSpeed;
        // resume old anim or begin new
        this.animCurrent.play();
        this.animCurrent.onComplete = function () {
            // need additional rotation - because in end of cur anim will show other coin side than result side
            if (animResult === self.animCurrent) {
                self.animCurrent.visible = false;

                self.animCurrent = (self.animCurrent === self.animCoinOrel) ? self.animCoinReshka : self.animCoinOrel;

                self.sndRotate.play();
                self.animCurrent.visible = true;
                self.animCurrent.animationSpeed = self.isDesktopHorizontal ? animationSpeed - 0.1 : self.constStartAnimSpeed;
                self.animCurrent.gotoAndPlay(0);
                self.animCurrent.onComplete = function () {
                    self.isDesktopHorizontal ? complete() : preComplete(coinSide, complete);
                };
            }
            else {
                self.isDesktopHorizontal ? complete() : preComplete(coinSide, complete);
            }
        };

        let showResult = () => {
            if (self.win) {
                self.sndWin.play();
            }
            else {
                self.sndLose.play();
            }

            self.ui.setResult(self.win, self.userChoice === GResultOrel, self.currencyPrecision, self.currencyDelimiter);

            let strResult = self.win ? "WIN" : "LOSE";
            window.parent.postMessage({isWbgMsg: true, name: 'showResult', strResult: strResult, win: self.win}, '*');
        };

        complete = function () {
            self.isCompleteShowResult = true;

            if (self.isDesktopHorizontal) {
                showResult();
            }

            if (self.isX2Mode && self.win > 0) {
                // self.ui.setLabelTotalBet(self.win, self.currencyPrecision, self.currencyDelimiter);
                self.ui.setState("UNLOCK_X2MODE");
            }
            else {
                const time = self.isAutoPlay ? 300 : 0;
                self.setCredits(self.credits + self.win);
                self.timeIdTakeWin = setTimeout(function () {
                    self.changeModelLocal("init");
                    self.space.s('server_action').next({name: 'doTake'});
                }, time);
            }
        };

        preComplete = function (coinSide, done) {
            self.animCurrent.visible = false;

            self.animCurrent = coinSide === "head" ? self.animCoinOrelStop : self.animCoinReshkaStop;

            self.sndRotate.play();
            self.animCurrent.visible = true;
            self.animCurrent.gotoAndPlay(0);
            self.animCurrent.animationSpeed = self.constStartAnimSpeed;
            self.animCurrent.onComplete = done;
            self.animCurrent.onFrameChange = (frame) => {
                if (frame === 8) {
                    showResult();
                }
            };
        };
    }

    onButtonPlaceBet() {
        this.isReady = false;
        this.space.s('server_action').next({name: 'setBetSide', param: this.userChoice === GResultOrel ? "head" : "tail"});
        this.space.s('server_action').next({name: 'setBetValue', param: this.ui.getTotalBet()});
        this.changeModelLocal("spin");
        this.space.s('server_action').next({name: 'doSpin', param: this.dataModelLast.state.bet});
    }

    onButtonMore() {
        this.space.s('server_action').next({name: 'setBetSide', param: this.userChoice === GResultOrel ? "head" : "tail"});
        this.space.s('server_action').next({name: 'setBetValue', param: this.ui.getTotalBet()});
        this.changeModelLocal("spin");
        this.space.s('server_action').next({name: 'doSpinWin', param: this.dataModelLast.state.bet});
    }

    onButtonStop() {
        this.changeModelLocal("init");
        this.space.s('server_action').next({name: 'doTake'});
    }

    onButtonSelectOrel() {
        this.userChoice = GResultOrel;
    }

    onButtonSelectReshka() {
        this.userChoice = GResultReshka;
    }

    // setBet(bet){
    //     if (bet < this.totalBetMin || bet > this.totalBetMax || bet > this.credits)
    //         return;
    //     // TODO: fix this - if not take win in double mode call setLabelTotalBet only in onModelChanged
    //     // if (!this.isX2Mode || (this.isX2Mode && this.win === 0))
    //         // this.ui.setLabelTotalBet(bet, this.currencyPrecision, this.currencyDelimiter);
    // }

    // onButtonBet(betValue) {
    //     this.setBet(betValue);
    // }

    onButtonHelp() {
        this.help.visible = !this.help.visible;
        window.parent.postMessage({isWbgMsg:true, name:'showHelp'}, '*');
    }

    onButtonSettings() {
        this.settings.visible = !this.settings.visible;
        if (!this.settings.visible) this.settings.close();
    }

    onButtonSettingsImg(indBack) {
        if (indBack < this.arrBackgrounds.length) {
            if (!SETTINGS.transparent_render) {
                for (let obj of this.arrBackgrounds) obj.visible = false;
                this.arrBackgrounds[indBack].visible = true;

                if (!this.isDesktopHorizontal)
                    window.space.s( 'change_ears_image' ).next(indBack);
            }
            else {
                this._setHTMLBackground(indBack);
            }

            GlobalSavedGameState.backgroundInd = indBack;
        }
    }

    onButtonSettingsApply(indBack) {
        this.settings.visible = !this.settings.visible;

        if (!this.settings.visible) {
            if (!SETTINGS.transparent_render) {
                for (let obj of this.arrBackgrounds) {
                    obj.visible = false;
                }
                this.arrBackgrounds[indBack].visible = true;
            }
            else {
                this._setHTMLBackground(indBack);
            }
            this.space.s('server_action').next({name: 'doSetSettings', param: {
                "background": this.settings.getCurInd(), "mode": this.isX2Mode, "autoplay": this.isAutoPlay}});
        }
    }

    /*onButtonSettingsGameMode() {
        this.settingsGameMode.visible = !this.settingsGameMode.visible;
        if (!this.settingsGameMode.visible) this.settingsGameMode.close();
    }*/

    setGameMode(isX2Mode) {
        // this.logoFix.visible = this.logoX2.visible = false;
        // isX2Mode ? this.logoX2.visible = true : this.logoFix.visible = true;
        // this.isX2Mode = isX2Mode;
        //
        // this.ui.setAutoPlayButtonVisible(!isX2Mode);
        // if (isX2Mode) {
        //     this.setAutoPlayButtonState(false);
        // }
    }

    /*onButtonSettingsGameModeApply(ind) {
        this.settingsGameMode.visible = !this.settingsGameMode.visible;

        this.setGameMode(ind > 0);

        this.space.s('server_action').next({name: 'doSetSettings', param: {
            "background": this.settings.getCurInd(), "mode": this.isX2Mode, "autoplay": this.isAutoPlay}});
    }*/

    onButtonAutoOff() {
        this.isAutoPlay = false;
        GlobalSavedGameState.isAutoEnable = this.isAutoPlay;
    }

    onButtonAutoOn() {
        if (!this.ui.isLockPlaceBetButton())
            this.onButtonPlaceBet();
        this.isAutoPlay = true;
        GlobalSavedGameState.isAutoEnable = this.isAutoPlay;
    }

    tryAutoStartRound(){
        if (this.isAutoPlay){
            if (!this.ui.isLockPlaceBetButton()) {
                this.onButtonPlaceBet();
            }
        }
    }

    onButtonExit() {
        // this.space.s( 'goLobby' ).next();
        goLobby();
    }
}



// WEBPACK FOOTER //
// ./src/mainscene.es6